import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Minimal API error handler für die Registration-App.
 * Zeigt dem Nutzer sichtbare Fehlermeldungen via MatSnackBar.
 */
@Injectable({ providedIn: 'root' })
export class ApiHelperService {

  constructor(private snackBar: MatSnackBar) {}

  onError(error: HttpErrorResponse | any): void {
    console.error('API error:', error?.message ?? error);

    const status = error?.status;
    let message = 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.';

    if (status === 0) {
      message = 'Server nicht erreichbar. Bitte prüfe deine Internetverbindung.';
    } else if (status === 409) {
      message = 'Diese E-Mail-Adresse ist bereits registriert.';
    } else if (status >= 500) {
      message = 'Serverfehler. Bitte versuche es später erneut.';
    } else if (status === 400) {
      message = 'Ungültige Eingabe. Bitte prüfe deine Daten.';
    }

    this.snackBar.open(message, 'OK', {
      duration: 6000,
      panelClass: ['registration-snackbar--error'],
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}
